module.exports = __webpack_public_path__ + "img/LUB00317.32afba47.png";